'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const BaseTileTargetCovering = renderWithRef('BaseTileTargetCovering', null, (o, t)=>jsx(RenderComp, {
        root: "div",
        forwardedRef: t,
        classNames: [
            'swan-base-tile-target-covering'
        ],
        props: o,
        children: o.children
    }));

export { BaseTileTargetCovering };
